/*jshint esversion: 6 */
import {
    addActionClass,
    addErrorClass,
    addLoadingClass,
    addSuccessClass,
    removeLoadingClass
} from "../../default/global/js/utilities/updateClasses";
import {itemcardSubscriptions} from "../../default/global/js/subscriptions";
import {hideIconbarHover, initIconbarHoverClose, showIconbarHover} from "../../default/global/js//iconbarHover";
import {initCustomSelects} from "../../default/global/js/customSelect";
import {initToggleSlide} from "../../default/global/js/toggle";
import {XhrService} from "../../default/global/ts/xhr.service";
import {appendScriptToDOM} from "../../default/global/js/utilities/functions";
import {initFormSubmitChanges} from "../../default/global/js/actionClick";
import {closeModal, showModal} from "../../default/global/js/modal";
import {initInputBody} from "../../default/global/js/inputfile";
import {focusInputGroups} from "../../default/global/js/checkInputGroups";
import {updateItemlistStickyOrderBarCount} from "../../default/global/js/itemlistStickyOrderBar";
import {getAllQuantityInputs} from "../../default/global/js//quantitySpinner";
import {setAccessibilityLiveRegionMessage} from "../../default/global/js/accessibilityLiveRegionService";

function updateBasketCount(doc) {
    for (let basketCount of document.querySelectorAll('.js-basketCount')) {
        let firstNewBasketCount = doc.querySelector('.js-basketCount');
        if (firstNewBasketCount) {
            let count = parseInt(firstNewBasketCount.innerText);
            if (isNaN(count)) {
                count = 0;
            }
            if (count === 0) {
                basketCount.style.display = "none";
            } else {
                addActionClass(basketCount, function () {
                    basketCount.style.display = "";
                });
            }
        }
    }
}

function updateItem(target, doc) {
    let dataItemNo = target.dataset.itemNo;
    if (dataItemNo) {
        let addOn = target.closest(".js-updateItem");
        if (addOn) {
            let newTarget = doc.querySelector('.js-addListItemToBasket[data-item-no="' + dataItemNo + '"]');
            if (newTarget) {
                let newaddOn = newTarget.closest('.js-updateItem');
                if (newaddOn) {
                    addOn.innerHTML = newaddOn.innerHTML;
                } else {
                    console.error("cannot update orderbutton");
                }
            }
        }
    }
}

function updateOrderButtonItemcard(doc) {
    let itemcardBuybox = document.querySelector(".itemcardBuybox");
    let newItemcardBuybox = doc.querySelector('.itemcardBuybox');

    if (itemcardBuybox) {
        itemcardBuybox.innerHTML = newItemcardBuybox.innerHTML;

        itemcardSubscriptions(itemcardBuybox);
        initCustomSelects(itemcardBuybox.querySelectorAll(".js-customSelect"));
    }
}

function updateHeaderBasket(doc,showHeaderBasket = true) {
    let delayBasketHover = 6000;
    if(GLOBALS){
        if(GLOBALS.delayHideBasketHover){
            delayBasketHover = GLOBALS.delayHideBasketHover;
        }
    }
    for (let headerBasket of document.querySelectorAll('.js-headerBasket')) {
        let newHeaderBasket = doc.querySelector('.js-headerBasket');
        if (newHeaderBasket) {
            headerBasket.innerHTML = newHeaderBasket.innerHTML;
            let basketCount = headerBasket.querySelector('.js-basketCount');
            const itemBasketBoxes = doc.querySelectorAll(".itemBasketBox");

            if(!itemBasketBoxes){
                showHeaderBasket = false;
            }else{
                if (basketCount) {
                    addActionClass(basketCount);
                }
                if(showHeaderBasket){
                    headerBasket.classList.add("showIconbarHover");
                    showIconbarHover(headerBasket);
                    initIconbarHoverClose(headerBasket.querySelectorAll(".iconbarHover__close"));

                    setTimeout(function () {
                        hideIconbarHover(headerBasket);
                    }, delayBasketHover);
                }
            }
        }
    }
}

function dispatchCustomUpdateBasketViewsEvent(data,name="updateBasketViews"){
    document.dispatchEvent(new CustomEvent(name, {
        detail: { data }
    }));
}

function eventListenerBasketViewQuantities(basketView, updateTimeout) {
    for (let quantity of basketView.querySelectorAll('.js-itemBasketList .quantity input[type="number"]')) {
        let form = quantity.closest(".js-itemBasketList");
        quantity.addEventListener("change", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
        quantity.addEventListener("keyup", function (e) {
            if(e.key === "Enter"){
                sendBasketForm(form, basketView);
            }
        });
    }
}

function eventListenerBasketViewSpDiscounts(basketView, updateTimeout) {
    for (let spDiscount of basketView.querySelectorAll('.js-itemBasketList .spDiscount input[type="number"]')) {
        let form = spDiscount.closest(".js-itemBasketList");
        let max = spDiscount.max;
        let value = spDiscount.value;
        spDiscount.addEventListener("change", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
        spDiscount.addEventListener("keyup", function (e) {
            if(e.key === "Enter"){
                sendBasketForm(form, basketView);
            }
        });
    }

}

function eventListenerBasketViewQuantitySpinners(basketView, updateTimeout) {
    for (let spinner of basketView.querySelectorAll('.js-itemBasketList .quantity .js-spinnerUp,.js-itemBasketList .quantity .js-spinnerDown')) {
        let form = spinner.closest(".js-itemBasketList");
        spinner.addEventListener("click", function () {
            clearTimeout(updateTimeout);
            updateTimeout = setTimeout(function () {
                sendBasketForm(form, basketView);
            }, 1000);
        });
    }
}

function updateAllBasketViews(basketView, newBasketView) {
    if (basketView && newBasketView) {
        let oldList = basketView.querySelector('.js-itemBasketList');
        let oldOrderBox = basketView.querySelector('.js-basketOrderBox');
        let oldSummary = basketView.querySelector('.js-basketSummary');
        let oldBasketPaymentButtons = basketView.querySelector('.js-basketPaymentButtons');

        let newList = newBasketView.querySelector('.js-itemBasketList');
        let newOrderBox = newBasketView.querySelector('.js-basketOrderBox');
        let newSummary = newBasketView.querySelector('.js-basketSummary');
        let newBasketPaymentButtons = newBasketView.querySelector('.js-basketPaymentButtons');

        setAccessibilityLiveRegionMessage(GLOBALS.tc.refreshedBasket);

        if (newList) {
            oldList.innerHTML = newList.innerHTML;
            removeLoadingClass(oldList);
            eventListenerBasketViewQuantities(basketView);
            eventListenerBasketViewQuantitySpinners(basketView);
            eventListenerBasketViewSpDiscounts(basketView);
        } else {
            basketView.innerHTML = newBasketView.innerHTML;
            return;
        }

        if (newOrderBox) {
            oldOrderBox.innerHTML = newOrderBox.innerHTML;
            removeLoadingClass(oldOrderBox);
            initToggleSlide(oldOrderBox.querySelectorAll(".js-toggleLinkSlide"));
            initFormSubmitChanges();
        }
        if (newSummary) {
            oldSummary.innerHTML = newSummary.innerHTML;
        }

        if (newBasketPaymentButtons) {
            oldBasketPaymentButtons.innerHTML = newBasketPaymentButtons.innerHTML;
            executeScripts(oldBasketPaymentButtons);
        }
    }
}

function executeScripts(element) {
    let scripts = element.querySelectorAll('script');

    scripts.forEach(script => {
        let newScript = document.createElement('script');
        newScript.src = script.src;
        document.head.appendChild(newScript);
        newScript.remove();
    });
}

function sendBasketForm(form, basketView) {
    let formData = new FormData(form);
    addLoadingClass(basketView.querySelector('.js-itemBasketList'));
    addLoadingClass(basketView.querySelector('.js-basketOrderBox'));
    fetch(form.action, {
        method: "POST",
        body: formData,
    })
        .then((response) => {
            if (!response.ok) {
                throw "Could not save data";
            }
            return response.text();
        })
        .then((data) => {
            let parser = new DOMParser();
            let doc = parser.parseFromString(data, "text/html");
            updateAllBasketViews(basketView, doc.getElementById('userBasket'));

            dispatchCustomUpdateBasketViewsEvent({
                data
            });

            console.log('Success:', data);
        })
        .catch((e) => {
            console.error('Error:', e);
        });
}

function checkValidCustomization(form) {
    let isValid = true;
    for(let field of form.querySelectorAll("input,select,textarea")){
        if(field.required && !field.value){
            isValid = false;
        }
    }
    return isValid;
}

export function triggerBasketBtns() {
    document.addEventListener("click", function (e) {
        let target = e.target;

        if (target.closest(".js-addListItemToBasket")) {
            target = target.closest(".js-addListItemToBasket");
            let form = target.closest("form");
            let orderButtonWrapper = target.closest(".orderButtonWrapper");
            let quantityInput = orderButtonWrapper.querySelector('.js-quantity-value');

            if (form && quantityInput) {
                if (quantityInput.value > 0) {
                    addLoadingClass(target);
                    target.ariaBusy="true";
                    let formData = new FormData(form);
                    let action = form.dataset.action;
                    formData.set('action', action);
                    XhrService.generalAjaxCall('cart', formData, 'POST', 'json').then(response => {
                        if (!response.status) {
                            throw "Could not save data";
                        }
                        const headerBasket = document.querySelector('.js-headerBasket');
                        if (headerBasket && response.headerBasketContent) {
                            var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                            updateHeaderBasket(doc);
                        }
                        if (response.tagManager) {
                            appendScriptToDOM(response.tagManager, true);
                        }
                        form.reset();
                        return response.status;
                    })
                        .catch((e) => {
                            target.ariaBusy="false";
                            addErrorClass(target);
                            console.error('Error:', e);
                            console.error('Action:', form.action);
                            console.error(formData);
                        }).finally(()=>{
                        updateItemlistStickyOrderBarCount();
                        setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);
                        addSuccessClass(target);
                        target.ariaBusy="false";
                    });
                }

            }
            e.preventDefault();
        }

        if (target.closest(".js-addToBasketItemcard")) {
            target = target.closest(".js-addToBasketItemcard");
            let form = target.closest("form");
            let orderButtonWrapper = target.closest(".orderButtonWrapper");
            let quantityInput = orderButtonWrapper.querySelector('.js-quantity-value');
            let customizableInputValue = form.dataset.customized;
            let quantityValue = 0;

            if ((form && quantityInput) || (form && customizableInputValue === '1'))  {
                if (quantityInput) {
                    quantityValue = quantityInput.value;
                }
                if (quantityValue > 0 || customizableInputValue === '1') {
                    addLoadingClass(target);
                    let fn = 'cart';
                    let formData = new FormData(form);
                    let action = form.dataset.action;
                    let isValid = true;
                    formData.set('action', action);
                    if (customizableInputValue === '1') {
                        fn = 'cartCustomize';
                    }

                    if(target.classList.contains("js-addToBasketItemcardCustomization")){
                        isValid = checkValidCustomization(form);
                        if(!isValid){
                            removeLoadingClass(target);
                            return;
                        }
                    }

                    XhrService.generalAjaxCall(fn, formData, 'POST', 'json').then(response => {
                        if (!response.status) {
                            throw "Could not save data";
                        }
                        addSuccessClass(target);
                        setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);
                        if (fn == 'cartCustomize') {
                            let existingModal = document.getElementById('modalUserQueue');
                            if (existingModal) {
                                existingModal.remove();
                            }

                            const parser = new DOMParser();
                            const customizeModalParser = parser.parseFromString(response.customizeModal, 'text/html');
                            const customizeModal = customizeModalParser.querySelector('.modal');

                            if(customizeModal){
                                document.body.appendChild(customizeModal);
                                initInputBody(customizeModal.querySelectorAll(".fileBody"));
                                focusInputGroups(customizeModal.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                                showModal(customizeModal);
                            }
                        } else {
                            const headerBasket = document.querySelector('.js-headerBasket');
                            if (headerBasket && response.headerBasketContent) {
                                var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                                updateHeaderBasket(doc);
                            }
                            if (response.tagManager) {
                                appendScriptToDOM(response.tagManager, true);
                            }
                            form.reset();
                            let existingModal = document.getElementById('modalUserQueue');
                            if (existingModal) {
                                closeModal(existingModal);
                            }
                        }

                        return response.status;
                    })
                        .catch((e) => {
                            addErrorClass(target);
                            console.error('Error:', e);
                        });
                }
            }
            e.preventDefault();
        }

        if (target.closest(".js-removeFromBasket")) {
            target = target.closest(".js-removeFromBasket");

            let basketView = document.getElementById("userBasket");

            let formData = new FormData();
            formData.set('action', target.dataset.action);
            formData.set('action_id', target.dataset.actionid);
            formData.set('var_code', target.dataset.var_code);
            formData.set('item_key', target.dataset.itemkey);

            addLoadingClass(target);

            if(basketView){
                fetch("?action=shop_remove_item_from_basket", {
                    method: "POST",
                    body: formData,
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw "Could not save data";
                        }
                        return response.text();
                    })
                    .then((data) => {
                        let parser = new DOMParser();
                        let doc = parser.parseFromString(data, "text/html");
                        if(doc.querySelector(".itemBasketList")){
                            updateAllBasketViews(basketView, doc.getElementById('userBasket'));
                            updateHeaderBasket(doc,false);
                        }else{
                            location.reload();
                        }

                        dispatchCustomUpdateBasketViewsEvent({
                            data
                        });
                        setAccessibilityLiveRegionMessage(GLOBALS.tc.removedItemFromBasket);
                    })
                    .catch((e) => {
                        addErrorClass(target);
                        console.error('Error:', e);
                    });
            }else{
                formData.set('action', target.dataset.action);

                XhrService.generalAjaxCall('cart', formData, 'POST', 'json').then(response => {
                    if (!response.status) {
                        throw "Could not save data";
                    }
                    addSuccessClass(target);
                    const headerBasket = document.querySelector('.js-headerBasket');
                    if (headerBasket && response.headerBasketContent) {
                        var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                        updateHeaderBasket(doc);
                    }
                    if (response.tagManager) {
                        appendScriptToDOM(response.tagManager, true);
                    }
                    setAccessibilityLiveRegionMessage(GLOBALS.tc.removedItemFromBasket);
                    return response.status;
                })
                    .catch((e) => {
                        addErrorClass(target);
                        console.error('Error:', e);
                    });
            }
            e.preventDefault();
        }

        if (target.closest(".js-saveBasketCustomization")) {
            target = target.closest(".js-saveBasketCustomization");
            addLoadingClass(target);

            let form = target.closest("form");
            let formData = new FormData(form);
            formData.set('action', form.dataset.action);

            XhrService.generalAjaxCall('saveCustomization', formData, 'POST', 'json').then(response => {
                if (!response.status) {
                    throw "Could not save data";
                }
                addSuccessClass(target);
                setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);
                let customizationData = response.inputDataArray;
                Object.keys(customizationData).forEach(key => {
                    let cleanKey = key.replace("input", "");
                    let customizationText = document.getElementById(cleanKey);
                    customizationText.innerHTML = customizationData[key];
                });
                form.reset();
                let existingModal = document.getElementById('modalUserQueue');
                if (existingModal) {
                    closeModal(existingModal);
                }
            })
                .catch((e) => {
                    addErrorClass(target);
                    console.error('Error:', e);
                });

            e.preventDefault();
        }

        if (target.closest(".js-basketEditCustomization")) {
            target = target.closest(".js-basketEditCustomization");
            addLoadingClass(target);

            let formData = new FormData();
            formData.set('action', target.dataset.action);
            formData.set('action_id', target.dataset.actionid);
            formData.set('customization_hash', target.dataset.customizationhash);

            XhrService.generalAjaxCall('editCustomization', formData, 'GET', 'json').then(response => {
                if (!response.status) {
                    throw "Could not save data";
                }
                addSuccessClass(target);
                setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);

                let itemBasketList = document.getElementById('form_user_basket');
                if (itemBasketList) {
                    let existingModal = document.getElementById('modalUserQueue');
                    if (existingModal) {
                        existingModal.remove();
                    }
                    let customizeModal = response.customizeModal;
                    let newElement = document.createElement('div');
                    newElement.innerHTML = customizeModal;
                    while (newElement.firstChild) {
                        itemBasketList.appendChild(newElement.firstChild);
                    }
                    newElement.remove();
                    initInputBody(document.getElementById("modalUserQueue").querySelectorAll(".fileBody"));
                    focusInputGroups(document.getElementById("modalUserQueue").querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                    showModal(document.getElementById("modalUserQueue"));
                }

                return response.status;
            })
                .catch((e) => {
                    addErrorClass(target);
                    console.error('Error:', e);
                });

            e.preventDefault();
        }

        if (target.closest(".js-addListItemToBasketAll")) {
            target = target.closest(".js-addListItemToBasketAll");
            let quantityInputs = getAllQuantityInputs();
            let forms = new Set();

            for(let qty of quantityInputs){
                let form = qty.closest("form");
                if(form){
                    forms.add(form);
                }
            }

            if (forms) {
                let formDatas = new FormData();
                for(let form of forms){
                    let qtyInput = form.querySelector('.quantity input[type="number"]');
                    if(qtyInput){
                        if(parseInt(qtyInput.value) > 0){
                            let formData = new FormData(form);
                            for (let pair of formData.entries()) {
                                formDatas.append(pair[0], pair[1]);
                            }
                        }
                    }
                }
                addLoadingClass(target);
                formDatas.set('action', 'shop_add_all_items_to_basket');

                XhrService.generalAjaxCall('cart', formDatas, 'POST', 'json').then(response => {
                    if (!response.status) {
                        throw "Could not save data";
                    }
                    const headerBasket = document.querySelector('.js-headerBasket');
                    if (headerBasket && response.headerBasketContent) {
                        var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                        updateHeaderBasket(doc);
                    }
                    if (response.tagManager) {
                        appendScriptToDOM(response.tagManager, true);
                    }
                    for(let form of forms){
                        form.reset();
                    }
                    updateItemlistStickyOrderBarCount();
                    addSuccessClass(target);
                    setAccessibilityLiveRegionMessage(GLOBALS.tc.addedItemToBasket);
                    return response.status;
                })
                    .catch((e) => {
                        addErrorClass(target);
                        console.error('Error:', e);
                        console.error(formDatas);
                    });

            }
            e.preventDefault();
        }

        if (target.closest(".js-addListItemToBasketAllItemPresentation")) {
            console.log('addListItemToBasketAllItemPresentation');
            target = target.closest(".js-addListItemToBasketAllItemPresentation");

            let items_nos = target.nextSibling.innerHTML;

            console.log(items_nos);

            if(items_nos.endsWith(",")){
                items_nos = items_nos.slice(0, -1);
            }

            let formData = new FormData();
            formData.set('items_nos', items_nos);


            XhrService.generalAjaxCall(
                'add_items_to_basket',
                formData,
                'POST',
                'json').then(
                function(response){
                    if (!response.status) {
                        throw "Could not save data";
                    }

                    const headerBasket = document.querySelector('.js-headerBasket');
                    if (headerBasket && response.headerBasketContent) {
                        var doc = new DOMParser().parseFromString(response.headerBasketContent, "text/html");
                        updateHeaderBasket(doc);
                    }
                    if (response.tagManager) {
                        appendScriptToDOM(response.tagManager, true);
                    }
                    addSuccessClass(target);
                    updateItemlistStickyOrderBarCount();
                    return response.status;
                }).catch((e) => {
                addErrorClass(target);
                console.error('Error:', e);
                console.error(formData);
            });
        }
    });
}

export function triggerUpdateBasketView() {
    let updateTimeout = false;
    let basketView = document.getElementById("userBasket");
    if (basketView) {
        eventListenerBasketViewQuantities(basketView, updateTimeout);
        eventListenerBasketViewQuantitySpinners(basketView, updateTimeout);
        eventListenerBasketViewSpDiscounts(basketView, updateTimeout);

        new CustomEvent('updateBasketViews', {
            detail: { message: 'Die Funktion wurde erfolgreich ausgeführt!' }
        });
    }
}